/* The mobile menu (§7). A drop-down, not a drawer — see the comment in header.liquid.

   `hidden` rather than a class does the hiding: it takes the menu out of the accessibility
   tree as well as off the screen, so a screen reader does not read six links that a sighted
   visitor cannot see. CSS then overrides it when open, which is why the stylesheet carries
   `[hidden]` explicitly.

   Focus is trapped while open and restored to the button on close, which is what makes the
   thing usable from a keyboard rather than merely operable. */
(function () {
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.getElementById('header-menu');
  if (!toggle || !menu) return;

  const FOCUSABLE = 'a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])';
  let open = false;

  function setOpen(next) {
    open = next;
    toggle.setAttribute('aria-expanded', String(next));
    menu.hidden = !next;
    document.body.classList.toggle('has-menu-open', next);

    // Focus is deliberately not moved into the menu on open. This is a disclosure, not a
    // modal dialog: the button stays focused, `aria-expanded` announces the state, and Tab
    // walks into the links from there. Moving focus programmatically also made the browser
    // draw its focus ring around the first link for someone who had only tapped, which is
    // the ring that should only ever appear for a keyboard.
    //
    // On close, focus returns to the button only if it is currently inside the menu — a tap
    // outside has already put it somewhere the visitor chose, and stealing it back is rude.
    if (!next && menu.contains(document.activeElement)) toggle.focus();
  }

  toggle.addEventListener('click', function () { setOpen(!open); });

  document.addEventListener('keydown', function (event) {
    if (!open) return;

    if (event.key === 'Escape') {
      setOpen(false);
      return;
    }

    if (event.key !== 'Tab') return;

    // Trap: the menu and the button that opened it are one loop, so tabbing past the last
    // link returns to the button rather than wandering into the page behind.
    const stops = [toggle, ...menu.querySelectorAll(FOCUSABLE)];
    const first = stops[0];
    const last = stops[stops.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  // A tap outside closes it. `pointerdown` rather than `click` so it closes before a link
  // under the finger has a chance to fire.
  document.addEventListener('pointerdown', function (event) {
    if (!open) return;
    if (menu.contains(event.target) || toggle.contains(event.target)) return;
    setOpen(false);
  });

  // Crossing the breakpoint with the menu open would leave a stray block under a desktop
  // header, and the button that closes it is no longer on screen.
  const wide = window.matchMedia('(min-width: 761px)');
  const onChange = function (event) { if (event.matches && open) setOpen(false); };
  if (wide.addEventListener) wide.addEventListener('change', onChange);
  else wide.addListener(onChange);
})();
